module.exports = __webpack_public_path__ + "img/rosegold@2x.43ff91a.webp";